import useUniqueId from '@dustin-web/microsite-components/src/hooks/use-unique-id'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { useState } from 'react'
type Props = {
  label: string
  value: string | null
  onSaveEndUserInformation: (value: string) => void
}
export const RequiredEndUserInformation = ({ label, value, onSaveEndUserInformation }: Props) => {
  const { translate } = useI18n()
  const [inputValue, setInputValue] = useState<string | null>(value)
  const id = useUniqueId('end-user-info')

  const isUnchanged = !!value && inputValue === value
  return (
    <div className="u-mb-12">
      <label htmlFor={id} className="u-color-danger">
        {label}
      </label>
      <input
        id={id}
        className="u-bg-gray-02"
        type={'text'}
        value={inputValue ?? ''}
        maxLength={255}
        onChange={e => setInputValue(e.target.value)}
      />
      <button
        type="button"
        className="button-stripped u-mb-0"
        disabled={(!value && !inputValue) || isUnchanged}
        onClick={() => onSaveEndUserInformation(inputValue ?? '')}>
        {translate('Save')}
      </button>
    </div>
  )
}
